<template>
  <div>
    <v-row>
      <v-col> {{ isAT ? "Atividades" : "Tarefas" }} desabilitadas </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="disabledTasksValue"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                {{ props.item.nome }}
              </td>
              <td>
                {{ props.item.descricao }}
              </td>
              <td>
                {{ props.item.municipioSolucao.nome }}
              </td>
              <td v-if="!props.item.municipioSolucao.desabilitado">
                <AppModalRecoverTask
                  @onRecover="onRecoverM"
                  :payload="{
                    nomeGrupo: props.item.nome,
                    tarefaId: props.item.municipioTarefaId,
                  }"
                >
                </AppModalRecoverTask>
              </td>
              <td
                v-if="props.item.municipioSolucao.desabilitado"
                class="desabilitado"
              >
                {{ isAT ? "Iniciativa" : "Solução" }} Desabilitada
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div>
              Não há {{ isAT ? "atividades" : "tarefas" }} desabilitadas
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppModalRecoverTask from "./ModalRecoverTask";
import { sortArrayAsc } from "../../../../helpers/utils";

export default {
  name: "AppRetrieveTask",
  props: {
    disabledTasks: { type: Array, required: true },
  },
  components: {
    AppModalRecoverTask,
  },

  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Solução",
          value: "municipioSolucao.nome",
        },
        { text: "Habilitar", value: "acoes", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["loading", "isAT"]),
    disabledTasksValue() {
      let a = this.disabledTasks.sort(function (a, b) {
        return (
          a.municipioSolucao.desabilitado - b.municipioSolucao.desabilitado
        );
      });

      return a;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onRecoverM() {
      this.$emit("onRecover");
    },
  },
  mounted() {
    if (this.isAT) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Iniciativa",
          value: "municipioSolucao.nome",
        },
        { text: "Habilitar", value: "acoes", sortable: false },
      ];
    }
  },
};
</script>
<style scoped>
.desabilitado {
  color: red;
}
</style>
